import { render, staticRenderFns } from "./VisitCard.vue?vue&type=template&id=690118ac&"
import script from "./VisitCard.vue?vue&type=script&lang=js&"
export * from "./VisitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports